import { DOCUMENT_PRINT_TYPE } from "@/static/documentPrintTypes";
import { plainToClass } from "class-transformer";
import { DocumentToPrintResponseItem } from "@/models/api/documents/DocumentToPrintResponse";

export class DocumentToPrint {
  id!: string;
  copyCount!: number;
  documentPrintType!: DOCUMENT_PRINT_TYPE;

  static fromDocumentToPrintResponseItem(documentToPrintResponseItem: DocumentToPrintResponseItem): DocumentToPrint {
    const documentToPrint = plainToClass(DocumentToPrint, documentToPrintResponseItem);
    documentToPrint.documentPrintType = DOCUMENT_PRINT_TYPE.Original;
    return documentToPrint;
  }
}
